import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';

function ContentModal({ children, open, handleClose }) {
    return (
        <Dialog open={open} onClose={handleClose}>
            {children}
        </Dialog>
    );
}

ContentModal.propTypes = {
    children: PropTypes.any,
    open: PropTypes.bool,
    handleClose: PropTypes.func,
};

ContentModal.defaultProps = {
    open: false,
};

export default ContentModal;
